let axios = require('axios');

export class AxiosFacade {

	constructor() {
		// https://youtu.be/BWNcuB3LQz8?t=600
		// New Instance: https://css-tricks.com/stay-dry-using-axios-for-api-requests/
        this.instance = axios.create({
			withCredentials: true,
			baseURL: process.env.MIX_API_URL
		});

		return this
			.defaultHeaders()
			.requestInterceptor()
			.responseInterceptor()
			.instance;
	}

    /**
     * Set Default Headers
     */
	defaultHeaders() {
		this.instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
		this.instance.defaults.headers.common['Accept'] = 'application/json'
		this.instance.defaults.headers.post['Content-Type'] = 'multipart/form-data';
        return this;
	}

    /**
     * Perform a task before the request is sent
     */
	requestInterceptor() {
		this.instance.interceptors.request.use(
			config => {
				config.headers['X-Socket-ID'] = window.Echo.socketId()
				return config
			},
			error => Promise.reject(error)
		);
        return this;
	}

    /**
     * Perform a task after the response is received
     */
	responseInterceptor() {
		this.instance.interceptors.response.use(
			response => response,
			error => {
				if (error.response.data.message === "CSRF token mismatch.") {
					window.location.reload();
				}
				return Promise.reject(error)
			}
		);
        return this;
	}

	static flattenErrorResponsetoString(error) {
		if (!error || error.response === undefined) { return error || 'An Unknown Error Occurred.';}
		return error.response.data.errors ?
			_.flatten(_.toArray(error.response.data.errors)).join('<br>') :
			error.response.data.message;
	}

	static getErrors(error) {
		return error.response ? error.response.data.errors : []
	}

}
